export default "__VITE_ASSET__ioVExmei__"